module.exports = __webpack_public_path__ + "img/automatic-cars.fa3b6e05.jpeg";